'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _underscore = require('../utils/underscore');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactUtils = require('react-utils');

var _UIButton = require('./UIButton');

var _UIButton2 = _interopRequireDefault(_UIButton);

var _UITooltip = require('../tooltip/UITooltip');

var _UITooltip2 = _interopRequireDefault(_UITooltip);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

exports.default = _react2.default.createClass({
  displayName: 'UIIconButton',

  propTypes: _extends({}, (0, _underscore.omit)(_UIButton2.default.propTypes, ['block', 'responsive']), {
    children: _react.PropTypes.node,
    className: _react.PropTypes.string,
    iconClassName: _react.PropTypes.string,
    placement: _UITooltip2.default.propTypes.placement,
    shape: _react.PropTypes.oneOf(['square', 'circle']),
    tooltip: _react.PropTypes.oneOfType([_react.PropTypes.bool, _react.PropTypes.node, _react.PropTypes.string]).isRequired
  }),

  getDefaultProps: function getDefaultProps() {
    return _extends({}, _UIButton2.default.defaultProps, {
      block: false,
      placement: _UITooltip2.default.defaultProps.placement,
      shape: 'square',
      tooltip: false,
      use: 'tertiary-light'
    });
  },
  getClassName: function getClassName(_ref) {
    var className = _ref.className,
        shape = _ref.shape;

    return (0, _reactUtils.classNames)('private-button--icon-only', { 'private-button--circle': shape === 'circle' }, className);
  },
  render: function render() {
    var _props = this.props,
        children = _props.children,
        className = _props.className,
        name = _props.name,
        placement = _props.placement,
        shape = _props.shape,
        tooltip = _props.tooltip,
        rest = _objectWithoutProperties(_props, ['children', 'className', 'name', 'placement', 'shape', 'tooltip']);

    var buttonContents = _react2.default.createElement(
      _UIButton2.default,
      _extends({}, rest, {
        className: this.getClassName({ className: className, shape: shape }),
        responsive: false
      }),
      children
    );

    if (tooltip) {
      return _react2.default.createElement(
        _UITooltip2.default,
        {
          title: typeof tooltip === 'boolean' ? name : tooltip,
          placement: placement
        },
        buttonContents
      );
    }

    return buttonContents;
  }
});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1282/js/button/UIIconButton.js
// module id = 285
// module chunks = 0